import { memo } from 'react';
import { Title } from 'src/components';
import classNames from 'classnames';
interface IProps {
    description: string;
}
export function ContentSapo({ description }: IProps) {
    if (!description) {
        return null;
    }

    return (
        <Title
            className={classNames(
                'sapo',
                'text-[19px] font-[800] leading-[1.6]',
                'text-[var(--dark)]',
                'mb-[24px]',
            )}
            renderAs="h2"
        >
            {description}
        </Title>
    );
}

export default memo(ContentSapo);
